import { AddEntityDialog } from "@/components/common/add-entity-dialog";
import { addStaffLevelSchema } from "@/zod-schemas/staff/add-staff-level-schema";
import { getStaffLevelFormValues } from "@/default-form-values/staff/default-staff-level-form-values";
import { useCreateStaffLevel } from "@/hooks/staff/use-staff-levels";

export function AddStaffLevel() {
  const createStaffLevel = useCreateStaffLevel();

  return (
    <AddEntityDialog
      entityName="Staff Level"
      schema={addStaffLevelSchema}
      defaultValues={getStaffLevelFormValues}
      onCreate={async (data) => {
        await createStaffLevel.mutateAsync({
          name: data.name,
        });
      }}
      buttonLabel="Add Level"
    />
  );
}
